module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-get-start-aaoic-link"
  }, [_c('Title', {
    attrs: {
      "props": _vm.props.title
    }
  }), _c('a', {
    staticClass: "custom-get-start-aaoic-link__link",
    attrs: {
      "href": _vm.props.adult_form,
      "target": "_blank"
    }
  }, [_vm._v("Adult Form ")]), _c('a', {
    staticClass: "custom-get-start-aaoic-link__link",
    attrs: {
      "href": _vm.props.child_form,
      "target": "_blank"
    }
  }, [_vm._v("Child Form")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-694603a2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-get-start-health-history-form/custom-get-start-health-history-form.pug
// module id = 603
// module chunks = 1